import React from 'react'
import GuestHostSection from '../Components/LandingPage/GuestHostSection'
import TravelogueFeature from '../Components/LandingPage/TravelogueFeature'
import AboutHero from '../Components/AboutUsPageComponents/AboutHero'
import AuthorsOfMonth from '../Components/LandingPage/AuthorsOfMonth'
import About from '../Components/AboutUsPageComponents/About'

const AboutUsPage = () => {
  return (
    <div>

        <AboutHero />
        <About />
        <AuthorsOfMonth/>
        <GuestHostSection />
    <TravelogueFeature /></div>
  )
}

export default AboutUsPage